import { render, staticRenderFns } from "./ring-central-integration-card.vue?vue&type=template&id=6c0e6580"
import script from "./ring-central-integration-card.vue?vue&type=script&lang=js"
export * from "./ring-central-integration-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports